import styled from 'styled-components';

export const ListContainer = styled.div`
  padding-bottom: 70px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0 25px;
    padding-bottom: 70px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 20px 40px;
    padding-bottom: 70px;
  }
`;

export const LocationsListContainer = styled.div<{ maxBlockHeight: number }>`
  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    max-height: ${({ maxBlockHeight }) => `${maxBlockHeight}px`};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 0 10px;

    label {
      width: 274px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    gap: 0 5px;
    label {
      width: 254px;
    }
  }
`;
